// extracted by mini-css-extract-plugin
export default {"collapse":"QuantityAvailable_collapse__bZfGT"};